import { render, staticRenderFns } from "./DemoAd.vue?vue&type=template&id=29318907&scoped=true"
import script from "./DemoAd.vue?vue&type=script&lang=js"
export * from "./DemoAd.vue?vue&type=script&lang=js"
import style0 from "./DemoAd.vue?vue&type=style&index=0&id=29318907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29318907",
  null
  
)

export default component.exports